export const colors = [
  '#E36213',
  '#6663DF',
  '#EB9A30',
  '#8878AF',
  '#D95E71',
  '#0B5BE1',
  '#540E78',
  '#EED995',
  '#4DA55A',
  '#17CAD2',
  '#5577B2',
  '#9D5991',
  '#73AFB2',
  '#A2C860',
  '#802020',
  '#F6BC05',
  '#345387',
  '#9DD5E5',
  '#90124A',
  '#697A8B',
  '#C7855C',
  '#0E8F95',
  '#845583',
  '#FA8072',
  '#2B4359',
  '#A9DFBF',
  '#5595FF',
  '#9492F4',
  '#1ABC9C',
  '#B2A7B4',
  '#641E16',
  '#75EE87',
  '#5A85EA',
  '#8FFFED',
  '#CB4335',
  '#FFBB61',
  '#A7CDCF',
  '#C49F0A',
  '#506A6C',
  '#7D6608',
];

export const colorsCategories = [
  'mint-green',
  'unmellow-yellow',
  'flavescent',
  'topaz',
  'salmon-pink-semitransparent',
  'salmon-pink',
  'manatee',
];

export const commonColors = [
  'red',
  'orange',
  'yellow',
  'olive',
  'green',
  'teal',
  'blue',
  'violet',
  'purple',
  'pink',
  'brown',
  'grey',
  'black',
];
